module.exports = __webpack_public_path__ + "img/charts.e49c9236.jpg";